import React from 'react';
import { ChildrenPropType } from '../../../../types/component';
var defaultProps = {};
export default function Default(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
Default.defaultProps = defaultProps;